import React from 'react';
import { Link } from 'react-router-dom';
import './Button.css';

/**
 * Reusable Button component
 * @param {Object} props
 * @param {string} props.variant - 'primary' | 'secondary'
 * @param {string} props.size - 'small' | 'medium' | 'large'
 * @param {string} props.to - Route path (makes it a Link)
 * @param {string} props.href - External URL (makes it an anchor)
 * @param {Function} props.onClick - Click handler
 * @param {boolean} props.disabled - Disabled state
 * @param {React.ReactNode} props.children - Button content
 */
const Button = React.memo(({ 
  variant = 'primary', 
  size = 'medium',
  to,
  href,
  onClick,
  disabled = false,
  children,
  className = '',
  type = 'button',
  ...props 
}) => {
  const baseClasses = `btn btn-${variant} btn-${size} ${className}`.trim();
  
  if (to) {
    return (
      <Link to={to} className={baseClasses} {...props}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a 
        href={href} 
        className={baseClasses}
        target="_blank"
        rel="noopener noreferrer"
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      type={type}
      className={baseClasses}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
});

Button.displayName = 'Button';

export default Button;

